<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'systemSet' }">系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>FTP日期过滤</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      FTP日期过滤
    </h1>
    <div class="view-content">

      <el-form ref="form" :model="form" label-width="100px" size="small">

        <el-card class="box-card">
          <div class="card-content">
            <el-form-item label="销售日报">
              <el-radio-group v-model="defaultValue">
                <el-radio :label="1">原始文件</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="销售周报">
              <el-radio-group v-model="defaultValue">
                <el-radio :label="1">原始文件</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="销售月报">
              <el-radio-group v-model="form.date_config_purchase">
                <el-radio :label="1">原始文件</el-radio>
                <el-radio :label="2">只保留上个月1号~31号的数据</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="采购日报">
              <el-radio-group v-model="defaultValue">
                <el-radio :label="1">原始文件</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="采购周报">
              <el-radio-group v-model="defaultValue">
                <el-radio :label="1">原始文件</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="采购月报">
              <el-radio-group v-model="form.date_config_sales">
                <el-radio :label="1">原始文件</el-radio>
                <el-radio :label="2">只保留上个月1号~31号的数据</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="库存日报">
              <el-radio-group v-model="defaultValue">
                <el-radio :label="1">原始文件</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="库存周报">
              <el-radio-group v-model="defaultValue">
                <el-radio :label="1">原始文件</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="库存月报">
              <el-radio-group v-model="form.date_config_stock">
                <el-radio :label="1">原始文件</el-radio>
                <el-radio :label="2">只保留上个月1号~31号的数据</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label=" ">
            <el-button type="primary" @click="onSubmit()" :loading="isLoading">保存</el-button>
          </el-form-item>
        </el-card>
      </el-form>

    </div>
  </div>
</template>

<script>
import {getSetting, setFtpDateSetting} from '@/api/index';

export default {
  name: "PeriodSet",
  data: () => ({
    isLoading: false,
    form:{
      date_config_purchase:'',// 销售
      date_config_sales:'',//采购
      date_config_stock:'',//库存
    },
    defaultValue:1
  }),
  created() {
    this.getDateFilteringSetting()
  },
  methods: {
    //FTP日期过滤获取数据
    getDateFilteringSetting(){
      let para={
        type:42
      }
      getSetting(para).then(res => {
        if (0 === res.status) {
          let data=res.data;
          try{
            this.form={
              date_config_purchase:data.date_config_purchase-0,// 销售
              date_config_sales:data.date_config_sales-0,//采购
              date_config_stock:data.date_config_stock-0,//库存
            }
          }catch (e) {
            this.form={
              date_config_purchase:1,// 销售
              date_config_sales:1,//采购
              date_config_stock:1,//库存
            }
          }
        }
      });
    },
    /*
      * FTP日期过滤 提交
      * */
    onSubmit(){
      setFtpDateSetting(this.form).then(res => {
        if (0 === res.status) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;
}

.time-input {
  width: 50px;
  margin: 0 10px;
}
.space{
  padding: 0 10px;
}

</style>